import axios, { CancelTokenSource } from 'axios';
import { CustomerDuplicateResponse, CustomerReviewHubResponse, FilterRequest, MergeSyncCustomersRequest } from '../model/customer-review-hub';
import config from 'config';
import { get, post, put } from 'api';

const customerURL = config.get('api.customer');

let token: CancelTokenSource;

const getCustomersForReviewHub = async (
  filterRequest: FilterRequest,
  page: number,
  pageSize: number,
  searchString: string,
): Promise<CustomerReviewHubResponse> => {
  if (token) {
    token.cancel();
  }

  let searchstr = searchString.replace('&', '%26');
  searchstr = searchstr == '' ? ' ' : searchstr;
  token = axios.CancelToken.source();
  const url = `${customerURL}/customersReviewHub/${searchstr}/${page}/${pageSize}`;
  const resp = await post<CustomerReviewHubResponse>(url, filterRequest, { cancelToken: token.token });
  return resp?.data;
};

const getDuplicateCustomers = async (
  crmCustomerId: number,
  phoneNumber: string,
  email: string,
): Promise<CustomerDuplicateResponse[]> => {
  if (token) {
    token.cancel();
  }

  token = axios.CancelToken.source();
  const url = `${customerURL}/duplicatieCustomers/${crmCustomerId}/${phoneNumber ?? 'none'}/${email ?? 'none'}`;
  const resp = await get<CustomerDuplicateResponse[]>(url, { cancelToken: token.token });
  return resp?.data;
};

const mergeSyncDuplicateCustomers = async (MergeSyncReq: MergeSyncCustomersRequest): Promise<void> => {
  const url = `${customerURL}/mergeSyncDuplicateCustomers`;
  await post<CustomerReviewHubResponse>(url, MergeSyncReq);
};

const syncCustomersFromReviewHub = async (crmCustomerIds: number[]): Promise<void> => {
  const url = `${customerURL}/syncCustomersReviewHub`;
  await put<CustomerReviewHubResponse>(url, crmCustomerIds);
};

export default {
  getCustomersForReviewHub,
  getDuplicateCustomers,
  mergeSyncDuplicateCustomers,
  syncCustomersFromReviewHub,
};
